import z from "zod";

export const ProjectProductSchema = z.enum(["solar", "battery"]);

export type ProjectProductT = z.infer<typeof ProjectProductSchema>;

export const PROJECT_PRODUCTS = ProjectProductSchema.options;

export const HomeownerInterestSchema = z.enum(["solar", "battery_only", "both"]);

export type HomeownerInterestT = z.infer<typeof HomeownerInterestSchema>;

const PRODUCTS_BY_HOMEOWNER_INTEREST: Record<HomeownerInterestT, ProjectProductT[]> = {
  solar: ["solar"],
  battery_only: ["battery"],
  both: ["solar", "battery"],
};

const isHomeownerInterest = (value?: string | null): value is HomeownerInterestT =>
  HomeownerInterestSchema.safeParse(value).success;

export const ProductTrackSchema = z.object({
  product: ProjectProductSchema,
  passedStageNames: z.array(z.string()),
  upcomingStageNames: z.array(z.string()),
});

export type ProductTrackT = z.infer<typeof ProductTrackSchema>;

export const ProjectTabSchema = z.object({
  id: z.number(),
  product: ProjectProductSchema,
  stage: z.string().nullish(),
  complete: z.boolean().optional(),
});

export type ProjectTabT = z.infer<typeof ProjectTabSchema>;

export const PRODUCT_LABELS: Record<ProjectProductT, string> = {
  solar: "Solar",
  battery: "Battery",
};

export const productsForHomeownerInterest = (homeownerInterest?: string | null): ProjectProductT[] =>
  isHomeownerInterest(homeownerInterest) ? PRODUCTS_BY_HOMEOWNER_INTEREST[homeownerInterest] : [];

export const requestedProposalProduct = (
  requestedProduct: ProjectProductT | null | undefined,
  homeownerInterest?: string | null,
): ProjectProductT | undefined => requestedProduct ?? productsForHomeownerInterest(homeownerInterest)[0];
